import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	contributorsLabel: {
		id: 'software-releases-launch-card.version-contributors.contributors-label',
		defaultMessage: 'Contributors',
		description: 'Label of the contributors field inside Launch Card',
	},
});
